import { Inject, Injectable } from '@angular/core';
import {
  IConfig,
  ScreenDetectorAnswer
} from '../@absract/@interface/IConfig.interface';
import {fromEvent, merge, Observable, Subject, Subscription, timer} from 'rxjs';
import {debounceTime, distinctUntilChanged, map, shareReplay, takeUntil, tap} from 'rxjs/operators';
import { ScreenTypeEnum } from '../@absract/@enums/screenType.enum';

@Injectable()
export class ScreenDetectorService {

  /**
   * */
  private readonly shortPrefix: string = 'c-sd-';

  /**
   * */
  private oConfigByKeySize: { [size: number]: string } = {};

  /**
   * */
  private arrayWithSizesOrderedByAsc = [];

  /**
   * */
  public lastScreenType = '';

  /**
   * */
  public subscription$: Observable<ScreenDetectorAnswer>;

  constructor(@Inject('ScreenDetectorConfig') private ScreenDetectorConfig) {
    // init config if inwoked from module
    this.subscription$ = merge(
      fromEvent(window, 'resize'),
      timer()
    ).pipe(
      shareReplay(1),
      // debounceTime(this.ScreenDetectorConfig.mzDebounceTime),
      map(this.getResult.bind(this))
    );

    this.init(this.ScreenDetectorConfig.config);
  }

  /**
   *
   * */
  public getSubscription (
    mzDebounceTime: number,
    alive$: Subject<any>,
    addDistinctUntilChanged: boolean
  ): Observable<ScreenDetectorAnswer>
  {
    return this.subscription$
      .pipe(
        debounceTime(mzDebounceTime),
        takeUntil(alive$),
        addDistinctUntilChanged
          ? distinctUntilChanged(
            (a: ScreenDetectorAnswer, b: ScreenDetectorAnswer) => {
              return a.type === b.type
            }
          )
          : tap()
      )

  }

  /**
   * */
  private init(config: IConfig) {
    // create object with key of size (not type) for later access
    for (const type of Object.keys(config)) {
      const size = config[type];
      this.oConfigByKeySize[size] = type;
      this.arrayWithSizesOrderedByAsc.push(size);
    }
    // sort by asc
    this.arrayWithSizesOrderedByAsc.sort((a, b) => {
      return b - a; //a - b;
    });
  }

  //TODO add mock if not config
  // getClientLang screen type
  public getScreenType(): string {
    const oConfig: IConfig = this.ScreenDetectorConfig.config,
      iDeviceWidth = document && document.documentElement.clientWidth;

    let r = ScreenTypeEnum.none;

    for (const size of this.arrayWithSizesOrderedByAsc) {
      if (iDeviceWidth >= size) {
        // @ts-ignore
        r = this.oConfigByKeySize[size];
        break;
      }
    }
    return r;
  }

  // getClientLang result for passed to flow
  private getResult(): ScreenDetectorAnswer {
    const screenType = this.getScreenType(); //@L - this.getScreenType();

    const result: ScreenDetectorAnswer = {
      type: screenType,
      width: document && document.documentElement.clientWidth,
      height: document && document.documentElement.clientHeight
    };

    // Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ/ÑÐ´Ð°Ð»Ð¸ÑÑ ÐºÐ»Ð°ÑÑÑ ÐµÑÐ»Ð¸ Ð±ÑÐ»Ð¸ Ð¿ÐµÑÐµÐ´Ð°Ð½Ñ Ð¿ÑÐ¸ Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸
    if (this.isFirstInvokeWithThisScreenType(screenType)) {
      //@L - this.isFirstInvokeWithThisScreenType(screenType)
      this.processingBaseClasses(result.type);
    }

    return result;
  }

  public isFirstInvokeWithThisScreenType(screenType: string) {
    // is first invoke -> return true;
    if (screenType !== this.lastScreenType) {
      // save new screen for later recognize
      this.lastScreenType = screenType;

      return true;
    }

    // is first invoke -> return true || is not first invoke -> return false
    return false;
  }

  public getClassName(className: string): string {
    return this.shortPrefix + className;
  }

  public getSelectors(): String[] {
    return this.ScreenDetectorConfig['selectors'];
  }

  public getConfig() {
    return this.ScreenDetectorConfig['config'];
  }

  // Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð±Ð°Ð·Ð¾Ð²ÑÑ ÐºÐ»Ð°ÑÑÐ¾Ð² ÐµÑÐ»Ð¸ Ð¸Ñ Ð¿ÐµÑÐµÐ´Ð°Ð²Ð°Ð»Ð¸ Ð¿ÑÐ¸ Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð¼Ð¾Ð´ÑÐ»Ñ
  public processingBaseClasses(screenType: string) {
    // getClientLang new class name by screen type
    const newClassName = this.getClassName(screenType);

    // getClientLang elements
    const classSelect =
      document &&
      document.querySelectorAll(
        this.ScreenDetectorConfig['selectors'].join(',')
      );

    // guard if isset elements
    if (classSelect.length > 1 || !classSelect[0]) return;

    // we have elements and this is first invoke with new screen type -> remove classes && add new class
    for (let i = 0; i < classSelect.length; i++) {
      // remove classes
      for (const screenTypeEnumKey in ScreenTypeEnum) {
        const classForRemove = this.getClassName(
          ScreenTypeEnum[screenTypeEnumKey]
        );

        // if this is not same same class -> remove
        if (newClassName !== classForRemove) {
          classSelect[i].classList.remove(classForRemove);
        }
      }

      // add new class
      classSelect[i].classList.add(newClassName);
    }
  }
}
